import { useAtomValue } from "jotai";
import { ConversationHistoryState } from "./conversation-history-atom-reducer";
import { ConversationHistoryAtom } from "./conversation-history-atom";

export function useConversationHistoryState(): ConversationHistoryState {
    const state = useAtomValue(ConversationHistoryAtom);
    return state;
}
